if (window.Vivition) {
    const vivisionWrapper = document.querySelector('[data-vivition-wrapper]');
    const vivisionLoader = document.querySelector('[data-vivition-loader]');
    const vivisionLoaderOverlay = document.querySelector('[data-vivition-loader-overlay]');
    const vivisionInteraction = document.querySelector('[data-vivition-interaction]');
    const vivitionZoomIn = document.querySelector('[data-vivition-zoom-in]');
    const vivitionZoomOut = document.querySelector('[data-vivition-zoom-out]');
    const vivitionFullScreen = document.querySelector('[data-vivition-full-screen]');

    vivisionWrapper?.addEventListener('mousedown', () => {
        vivisionInteraction.style.opacity = 0;
    });

    vivisionWrapper?.addEventListener('touchmove', () => {
        vivisionInteraction.style.opacity = 0;
    });

    vivitionZoomIn?.addEventListener('click', (e) => {
        e.preventDefault();
        window.Vivition.API.ZoomIn();
    });

    vivitionZoomOut?.addEventListener('click', (e) => {
        e.preventDefault();
        window.Vivition.API.ZoomOut();
    });

    vivitionFullScreen?.addEventListener('click', (e) => {
        e.preventDefault();

        if (document.fullscreenElement === vivisionWrapper) {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        } else {
            if (vivisionWrapper.requestFullscreen) {
                vivisionWrapper.requestFullscreen();
            } else if (vivisionWrapper.webkitRequestFullscreen) {
                vivisionWrapper.webkitRequestFullscreen();
            } else if (vivisionWrapper.msRequestFullscreen) {
                vivisionWrapper.msRequestFullscreen();
            }
        }
    });

    const circumference = vivisionLoader.r.baseVal.value * 2 * Math.PI;
    const setProgress = (percent) => {
        const offset = circumference - percent / 100 * circumference;
        vivisionLoader.style.strokeDashoffset = offset;
    }

    vivisionLoader.style.strokeDasharray = `${circumference} ${circumference}`;
    vivisionLoader.style.strokeDashoffset = `${circumference}`;

    window.Vivition.API.AddEventListener({
        event: 'readystate',
        callback: (e) => {
            setProgress(e.firstrow);

            if (e.firstrow === 100) {
                setTimeout(() => {
                    vivisionLoaderOverlay.style.opacity = 0;
                }, 200);

                setTimeout(() => {
                    vivisionInteraction.style.opacity = 1;
                }, 400);
            }
        }
    });
}
